import { Type, type Static } from "typebox";
import { ProductKeySchema, SuiteIdentityV1Schema } from "./identity.ts";

export const SessionIntrospectionRequestV1Schema = Type.Object({
  version: Type.Literal(1), childToken: Type.String({ minLength: 32, maxLength: 256 }),
  product: ProductKeySchema,
}, { additionalProperties: false });
export type SessionIntrospectionRequestV1 = Static<typeof SessionIntrospectionRequestV1Schema>;

export const SessionIntrospectionResponseV1Schema = Type.Union([
  Type.Object({ version: Type.Literal(1), active: Type.Literal(true), identity: SuiteIdentityV1Schema }, { additionalProperties: false }),
  Type.Object({ version: Type.Literal(1), active: Type.Literal(false), reason: Type.String({ maxLength: 64 }) }, { additionalProperties: false }),
]);
export type SessionIntrospectionResponseV1 = Static<typeof SessionIntrospectionResponseV1Schema>;

export const SwitchOrganizationRequestV1Schema = Type.Object({
  version: Type.Literal(1), childToken: Type.String({ minLength: 32, maxLength: 256 }),
  workosOrganizationId: Type.String({ minLength: 1, maxLength: 255 }),
  destinationProduct: ProductKeySchema,
}, { additionalProperties: false });
export type SwitchOrganizationRequestV1 = Static<typeof SwitchOrganizationRequestV1Schema>;

export const LogoutRequestV1Schema = Type.Object({
  version: Type.Literal(1), childToken: Type.String({ minLength: 32, maxLength: 512 }),
}, { additionalProperties: false });
export type LogoutRequestV1 = Static<typeof LogoutRequestV1Schema>;

export const LogoutResponseV1Schema = Type.Object({
  version: Type.Literal(1), loggedOut: Type.Literal(true),
}, { additionalProperties: false });
export type LogoutResponseV1 = Static<typeof LogoutResponseV1Schema>;

export const RevocationEventV1Schema = Type.Object({
  version: Type.Literal(1), cursor: Type.Integer({ minimum: 1 }),
  childSessionId: Type.String({ format: "uuid" }), sessionEpoch: Type.Integer({ minimum: 1 }),
  reason: Type.String({ minLength: 1, maxLength: 64 }), occurredAt: Type.String({ format: "date-time" }),
}, { additionalProperties: false });
export type RevocationEventV1 = Static<typeof RevocationEventV1Schema>;
